<script setup lang="ts">
defineOptions({
  name: 'TutorLegalColumn',
})
</script>

<template>
  <div class="tutor-legal-column">
    <slot />
  </div>
</template>

<style lang="scss" scoped src="./TutorLegalColumn.scss" />
